import {
  useIntegrator,
  type POSLayoutMode,
  type POSWidgetVisibilityEventData,
} from '@nsftx/seven-client-retail-vue-integrator'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useWidgetsStore = defineStore('widgetsStore', () => {
  const { emitWidgetVisibilityChange } = useIntegrator()

  const isLatestTicketsWidgetSelected = ref(false)
  const isShortcutsWidgetSelected = ref(false)
  const isCalculatorWidgetSelected = ref(false)
  const activeLayoutMode = ref<POSLayoutMode>('default')
  const hideWidgets = ref(false)

  const clearWidgetSelections = () => {
    isLatestTicketsWidgetSelected.value = false
    isShortcutsWidgetSelected.value = false
    isCalculatorWidgetSelected.value = false
  }

  const toggleLatestBetslips = () => {
    if (hideWidgets.value) {
      clearWidgetSelections()
    }
    hideWidgets.value = false
    isLatestTicketsWidgetSelected.value = !isLatestTicketsWidgetSelected.value
    emitWidgetVisibilityChange({
      widgetId: 'slip-list',
      visible: isLatestTicketsWidgetSelected.value,
    })
  }

  const toggleShortcuts = () => {
    if (hideWidgets.value) {
      clearWidgetSelections()
    }
    hideWidgets.value = false
    isShortcutsWidgetSelected.value = !isShortcutsWidgetSelected.value
    emitWidgetVisibilityChange({
      widgetId: 'shortcuts',
      visible: isShortcutsWidgetSelected.value,
    })
  }

  const toggleCalculator = () => {
    if (hideWidgets.value) {
      clearWidgetSelections()
    }
    hideWidgets.value = false
    isCalculatorWidgetSelected.value = !isCalculatorWidgetSelected.value
    emitWidgetVisibilityChange({
      widgetId: 'calculator',
      visible: isCalculatorWidgetSelected.value,
    })
  }

  const setLayoutMode = (mode: POSLayoutMode) => {
    activeLayoutMode.value = mode
    hideWidgets.value = mode === 'full-page'
  }

  const setWidgetVisibility = ({ widgetId, visible }: POSWidgetVisibilityEventData) => {
    hideWidgets.value = false

    switch (widgetId) {
      case 'slip-list':
        isLatestTicketsWidgetSelected.value = visible
        break
      case 'calculator':
        isCalculatorWidgetSelected.value = visible
        break
      case 'shortcuts':
        isShortcutsWidgetSelected.value = visible
        break
      default:
        break
    }
  }

  return {
    isLatestTicketsWidgetSelected,
    isShortcutsWidgetSelected,
    isCalculatorWidgetSelected,
    activeLayoutMode,
    hideWidgets,
    toggleLatestBetslips,
    toggleShortcuts,
    toggleCalculator,
    setLayoutMode,
    setWidgetVisibility,
    clearWidgetSelections,
  }
})
